var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClose3X(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.22528 2.22552C2.55072 1.90009 3.07835 1.90009 3.40379 2.22552L7.99998 6.82172L12.5962 2.22552C12.9216 1.90009 13.4493 1.90009 13.7747 2.22552C14.1001 2.55096 14.1001 3.0786 13.7747 3.40403L9.1785 8.00023L13.7747 12.5964C14.1001 12.9219 14.1001 13.4495 13.7747 13.7749C13.4493 14.1004 12.9216 14.1004 12.5962 13.7749L7.99998 9.17874L3.40379 13.7749C3.07835 14.1004 2.55072 14.1004 2.22528 13.7749C1.89984 13.4495 1.89984 12.9219 2.22528 12.5964L6.82147 8.00023L2.22528 3.40403C1.89984 3.0786 1.89984 2.55096 2.22528 2.22552Z",
    fill: "#132322"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose3X);
export default __webpack_public_path__ + "static/media/close@3x.a30a8a1db39c69f50a19aa3c34876918.svg";
export { ForwardRef as ReactComponent };